import { render, staticRenderFns } from "./detective.vue?vue&type=template&id=1378d850&"
import script from "./detective.vue?vue&type=script&lang=js&"
export * from "./detective.vue?vue&type=script&lang=js&"
import style0 from "./detective.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../usr/local/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports